export const WEB_ORDER_URL = "/api/web-orders/3.0";
